module.exports = __webpack_public_path__ + "static/media/icon-mail--active.a1b29573.svg";